import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
export var AbilityContext = createContext(null);
export var Can = createContextualCan(AbilityContext.Consumer);
